<template>
  <transition name="modal">
    <div class="modalcon">
      <div class="modal-mask">
        <div class="modal-wrapper">
          <div class="modal-container" @click.stop> 
            <form id="addAdd" method="POST" action="" v-on:submit.prevent="NewAddr" enctype="form-data">
              <div class="modal-header">
                <h5 class="m-0">Add New Address</h5>
                <div class="closebtn" @click="$emit('close')">X</div>
              </div>
              <div class="modal-body">
                <div class="form-group row">
                  <div class="col-sm-6">
                    <button type="button" class="btn btn-info btn-block" @click="getLatLongAddress"> 
                       <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" class="svgControl"><g fill="none" fill-rule="evenodd"><path d="M0 0h16v16H0z"></path><path class="" fill="#fff" d="M8 5.3a2.7 2.7 0 1 0 0 5.4 2.7 2.7 0 1 0 0-5.4zm6 2A6 6 0 0 0 8.7 2V.7H7.3V2A6 6 0 0 0 2 7.3H.7v1.4H2A6 6 0 0 0 7.3 14v1.3h1.4V14A6 6 0 0 0 14 8.7h1.3V7.3H14zm-6 5.4A4.7 4.7 0 0 1 3.3 8 4.7 4.7 0 0 1 8 3.3 4.7 4.7 0 0 1 12.7 8 4.7 4.7 0 0 1 8 12.7z"></path></g>
                       </svg>
                       Use my current location
                    </button>
                  </div>
                </div>
                <div class="form-group row" :class="{error: validation.hasError('firstname')}">
                  <div class="col-sm-6">
                    <input type="text" class="form-control inmarginbtm" :placeholder="getAddressLabel(countryId,'firstName')" v-model="firstname" maxlength="32"
                           name="firstname" @keydown="validateName" @paste="handleNamePaste" required>
                    <div class="message">{{ validation.firstError('firstname') }}</div>
                  </div>
                  <div class="col-sm-6">
                    <input type="text" class="form-control" :placeholder="getAddressLabel(countryId,'lastName')" v-model="lastname" name="lastname"
                           maxlength="32" @keydown="validateName" @paste="handleNamePaste" required>
                  </div>
                </div>
                <div class="form-group row" :class="{error: validation.hasError('address1')}">
                  <div class="col-sm-12">
                    <input type="text" class="form-control" :placeholder="getAddressLabel(countryId,'address1')" v-model="address1"
                           maxlength="35" name="address1">
                    <div class="message">{{ validation.firstError('address1') }}</div>
                  </div>
                </div>
                <div class="form-group row" :class="{error: validation.hasError('address2')}">
                  <div class="col-sm-12 ">
                    <input type="text" class="form-control" :placeholder="getAddressLabel(countryId,'address2')" v-model="address2"
                           maxlength="35" name="address2">
                    <div class="message">{{ validation.firstError('address2') }}</div>
                  </div>
                </div>
                <div v-if="isSelectedCountryIndia" class="form-group row">
                  <div class="col-sm-12">
                    <input type="text" class="form-control" :placeholder="getAddressLabel(countryId,'address3')" v-model="address3" maxlength="50"
                           name="address3">
                  </div>
                </div>
                <div class="row" v-if="!isSelectedCountryUAE">
                  <div class="col-sm-6" :class="{error: validation.hasError('postcode')}">
                    <div class="form-group">
                      <input class="form-control" :placeholder="getAddressLabel(countryId,'postcode')"
                             v-on:keydown="validatePinCode($event, postcodeLength, countryId)" @paste="handlePostPaste($event, countryId)" value="" v-model="postcode" name="postcode" :maxlength="postcodeLength ">
                      <div class="message">{{ validation.firstError('postcode') }}</div>
                    </div>
                  </div>
                  <div class="col-sm-6" :class="{error: validation.hasError('city')}">
                    <div class="form-group">
                      <input type="text" class="form-control" :placeholder="getAddressLabel(countryId,'city')" v-model="city" @keydown="validateName" @paste="handleNamePaste"
                             maxlength="32"  name="city">
                      <div class="message">{{ validation.firstError('city') }}</div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-6" :class="{error: validation.hasError('countryId')}">
                    <div class="form-group">
                      <select name="countrySelectBox" class="form-control" :placeholder="getAddressLabel(countryId,'countryId')" v-model="countryId" @change="getCountryStates()"
                        required>
                        <option value="0" selected>Select Country</option>
                        <option v-for="con in country_detail_data" v-bind:value="con.id">
                          {{ con.name }}
                        </option>
                      </select>
                      <div class="message">{{ validation.firstError('countryId') }}</div>
                    </div>
                  </div>
                  <div class="col-sm-6" :class="{error: validation.hasError('zone_id')}">
                    <div class="form-group">
                      <select class="form-control" :placeholder="getAddressLabel(countryId,'zone_id')" name="zone_id" v-model="zone_id" required>
                        <option value="0" selected>{{`Select ${getAddressLabel(countryId,'zone_id')}`}}</option>
                        <option v-for="zn in zones" v-bind:value="zn.id">
                          {{ zn.name }}
                        </option>
                      </select>
                      <div class="message">{{ validation.firstError('zone_id') }}</div>
                    </div>
                  </div>
                </div>
                <div class="form-group row" :class="{error: validation.hasError('city')}" v-if="isSelectedCountryUAE">
                  <div class="col-sm-12">
                    <input type="text" class="form-control" :placeholder="getAddressLabel(countryId,'city')" v-model="city" @keydown="validateName" @paste="handleNamePaste"
                             maxlength="32"  name="city">
                    <div class="message">{{ validation.firstError('city') }}</div>
                  </div>
                </div>
                <div class="form-group row">
                  <div :class="{error: validation.hasError('phone_no'), 'col-sm-6': isNewUser && !(getUser && getUser.email), 'col-sm-12': !(isNewUser && !(getUser && getUser.email))}">
                    <div class="country-phone-code">
                      <select name="countrySelectBox" class="form-control country-code" v-model="countryCode">
                        <option v-for="con in country_detail_data" :key="con.id" :value="con.country_code">
                          +{{ con.country_code }}
                        </option>
                      </select>
                      <input type="text" class="form-control" name="phone_no" :placeholder="getAddressLabel(countryId,'phone_no')" v-on:keydown="phoneNumberUpdate($event)" value=""
                             :maxlength="getPhonelength(countryId, countries)" v-model="phone_no">
                    </div>
                    <div class="message">{{ validation.firstError('phone_no') }}</div>
                  </div>
                  <div v-if="isNewUser && !(getUser && getUser.email)" class="col-sm-6" :class="{error: validation.hasError('email')}">
                    <div>
                      <input type="text" class="form-control" name="email" :placeholder="getAddressLabel(countryId,'email')" value="" maxlength="95" v-model="email">
                      <div class="message">{{ validation.firstError('email') }}</div>
                    </div>
                  </div>
                </div>
                <div v-if="isNewUser && !(getUser && getUser.email)" class="form-group row">
                  <div class="col-sm-12" :class="{error: validation.hasError('gender')}">
                    <div class='radio-input-wrapper form-control d-flex'>
                      Gender
                      <span class='d-flex justify-content-center align-items-center radio-input-control'>
                        <input class='pointer' type="radio" id="male" name="gender" value="M" v-model="gender">
                        <label for="male">Male</label>
                      </span>
                      <span class='d-flex justify-content-center align-items-center radio-input-control'>
                        <input class='pointer' type="radio" id="female" name="gender" value="F" v-model="gender">
                        <label for="female">Female</label>
                      </span>
                      <span class='d-flex justify-content-center align-items-center radio-input-control'>
                        <input class='pointer' type="radio" id="others" name="gender" value="Others" v-model="gender">
                        <label for="others">Other</label>
                      </span>
                    </div>
                    <div class="message">{{ validation.firstError('gender') }}</div>
                  </div>
                </div>
                <div class="form-check">
                  <label class="form-check-label">
                    <input type="checkbox" class="form-check-input" name="is_default" v-model="is_default">
                    Make this my default address
                  </label>
                </div>
              </div>
              <div class="modal-footer">
                <div class="row">
                  <div class="col-md-6 col-6">
                    <button type="button" class="btn btn-secondary btn-block" @click="$emit('close')">Cancel</button>
                  </div>
                  <div class="col-md-6 col-6">
                    <button type="submit" class="btn btn-red btn-block">Save</button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
  var $ = require('jquery')
  window.jQuery = $
  import SimpleVueValidation from 'simple-vue-validator'

  var Validator = SimpleVueValidation.Validator
  import {mapGetters} from 'vuex'
  import Vue from 'vue'
  import nameValidationMixin from '../../mixins/validationMixin'
  import { getAddressLabel } from '../../assets/js/common'
  import {getPhonelength} from '../../assets/js/utils'
  import debounce from 'lodash/debounce'

  export default {
    mixins: [nameValidationMixin],
    props: ['procountry', 'getzone', 'upAddFun', 'getUser', 'continueToCheckout', 'selAddr', 'callerComp'],
    data () {
      return {
        userId: '',
        editForm: {},
        firstname: this.getUser.firstname,
        address_id: '',
        lastname: this.getUser.lastname,
        address1: '',
        address2: '',
        address3: '',
        postcode: '',
        city: '',
        zone_id: 0,
        countryId: this.$store.state.selectedCountryAddress.countryId,
        countryCode: this.$store.state.selectedCountryAddress.country_code,
        phone_no: this.getUser.telephone || '',
        is_default: '',
        zonefor: '', // this.getzone,
        submitted: false,
        addressesFound: false,
        autofillData: {},
        timeout: null,
        email: '',
        gender: '',
        getAddressLabel: getAddressLabel,
        getPhonelength: getPhonelength
      }
    },
    created: function () {
      this.$store.commit('SET_GLOBAL_SETTING_KEYS', ['pincode_length_validation', 'SHOW_WEB_MENU_WOMEN', 'SHOW_WEB_MENU_MEN', 'SHOW_WEB_MENU_KIDS'])
    },
    methods: {
      phoneNumberUpdate (e) {
        const reg = new RegExp('^[0-9]$')
        if ((!reg.test(e.key)) && !(e.key === 'Backspace' || e.key === 'Delete' || e.key === 'ArrowLeft' || e.key === 'ArrowRight' || e.key === 'Tab')) {
          e.preventDefault()
        }
      },
      NewAddr: debounce(function () {
        var this_ = this
        this.submitted = true
        this.$validate().then((success) => {
          if (success) {
            var data = {
              firstname: this_.firstname,
              address_id: '',
              lastname: this_.lastname,
              address1: this_.address1,
              address2: this_.address2,
              address3: this_.address3,
              postcode: this.isSelectedCountryUAE ? '00000' : this_.postcode,
              city: this_.city,
              zone_id: this_.zone_id,
              country_id: this_.countryId,
              country_code: this_.countryCode,
              phone_no: this_.phone_no,
              is_default: this_.is_default,
              zonefor: this_.zonefor
            }
            if (this.isNewUser && !(this.getUser && this.getUser.email)) {
              data = {
                ...data,
                gender: this.gender,
                email: this.email,
                is_new_user: 1
              }
            }
            this_.$store.dispatch('ADDRESS', {...data, is_default: this_.addresses && this_.addresses.slice(0, -1).length ? data.is_default : true})
            .then((res) => {
              this.$store.commit('GTAG_EVENT', {eventName: 'add_shipping_info', payload: {value: this.getUserTatvicBuyNowItem && this.getUserTatvicBuyNowItem[0].price, items: this.getUserTatvicBuyNowItem}})
              const latestAddress = res[res.length - 2]
              this.$store.dispatch('SET_ORDER_ADDRESS', latestAddress.id)
              this_.$parent.newAddressModal = false
              this_.$parent.selectedAddId = latestAddress.id
              if (res && this.isNewUser && !(this.getUser && this.getUser.email)) {
                this.$store.dispatch('USER')
              }
            })
            .catch(error => {
              Vue.toasted.show(error.data.title, {
                theme: 'primary',
                className: 'toasted-customred',
                position: 'top-right',
                duration: 5000
              })
            })
          }
        })
      }, 1000),
      getLatLongAddress: function () {
        this.$store.commit('GTAG_EVENT', {eventName: 'useMyCurrentLocation_click', payload: {}})
        navigator.geolocation.getCurrentPosition(pos => {
          let myLatlng = {}
          myLatlng.latitude = pos.coords.latitude
          myLatlng.longitude = pos.coords.longitude
          this.$store.dispatch('GET_GOOGLE_LOCATION_ADDRESS_DATA', myLatlng).then(response => {
            if (response.status === 'success' && response.result && response.result.length > 0) {
              let parts = response.result[0].address_components
              parts.forEach(part => {
                if (part.types.includes('postal_code')) {
                  this.autofillData.postalCode = part.long_name
                }
                if (part.types.includes('administrative_area_level_1')) {
                  this.autofillData.politicalState = part.long_name
                }
                if (part.types.includes('administrative_area_level_2')) {
                  this.autofillData.politicalCity = part.long_name
                }
                if (part.types.includes('street_number') || part.types.includes('route') || part.types.includes('premise') || part.types.includes('sublocality_level_2')) {
                  this.autofillData.streetName = part.long_name
                }
                if (part.types.includes('neighborhood') || part.types.includes('landmark') || part.types.includes('sublocality_level_1')) {
                  this.autofillData.landMark = part.long_name
                }
              })
              this.postcode = this.autofillData.postalCode ? this.autofillData.postalCode : ''
              this.city = this.autofillData.politicalCity ? this.autofillData.politicalCity : ''
              this.address2 = this.autofillData.streetName ? this.autofillData.streetName : ''
              this.address3 = this.autofillData.landMark ? this.autofillData.landMark : ''
              let tempZoneData = this.zones && this.zones.filter((zn) => {
                return zn.name === this.autofillData.politicalState
              })
              this.zone_id = tempZoneData[0].id
            }
          })
        }, err => {
          Vue.toasted.show(err.message, {theme: 'primary', className: 'toasted-customred', position: 'top-right', duration: 5000})
        })
      },
      getCountryStates: function () {
        this.postcode = ''
        this.$store.dispatch('ZONES', this.countryId)
        this.postcodeLength
      }
    },
    validators: {
      firstname: function (value) {
        return Validator.value(value).required()
      },
      address1: function (value) {
        return Validator.value(value).required().minLength(4).maxLength(35)
      },
      address2: function (value) {
        return (this.isSelectedCountryIndia || this.isSelectedCountryUK || this.isSelectedCountryUAE) && Validator.value(value).required()
      },
      postcode: function (value) {
        return !this.isSelectedCountryUAE && Validator.value(value).required().custom(function () {
          var country = $('#addAdd').find('[name="countrySelectBox"]').val()
          var regex = ''
          if (country === '99') {
            regex = new RegExp(/^[1-9][0-9]{5}$/)
            if (!regex.test(value)) {
              return 'Invalid postal code'
            }
          } else if (country === '21') {
            regex = new RegExp(/^[1-9]{1}[0-9]{3}$/) //  Belgium
            if (!regex.test(value)) {
              return 'Invalid postal code'
            }
          } else if (country === '203') {
            regex = new RegExp(/^(s-|S-){0,1}[0-9]{3}\s?[0-9]{2}$/) //  Sweden
            if (!regex.test(value)) {
              return 'Invalid postal code'
            }
          } else if (country === '57') {
            regex = new RegExp(/^([D-d][K-k])?( |-)?[1-9]{1}[0-9]{3}$/) //  Denmark
            if (!regex.test(value)) {
              return 'Invalid postal code'
            }
          } else if (country === '195') {
            regex = new RegExp(/^([1-9]{2}|[0-9][1-9]|[1-9][0-9])[0-9]{3}$/) //  Spain
            if (!regex.test(value)) {
              return 'Invalid postal code'
            }
          } else if (country === '150') {
            regex = new RegExp(/^[1-9][0-9]{3}\s?([a-zA-Z]{2})?$/) //  Netherlands
            if (!regex.test(value)) {
              return 'Invalid postal code'
            }
          } else if (country === '105') {
            regex = new RegExp(/^(V-|I-)?[0-9]{5}$/) //  Italy
            if (!regex.test(value)) {
              return 'Invalid postal code'
            }
          } else if (country === '13') {
            regex = new RegExp(/^(0[289][0-9]{2})|([1345689][0-9]{3})|(2[0-8][0-9]{2})|(290[0-9])|(291[0-4])|(7[0-4][0-9]{2})|(7[8-9][0-9]{2})$/) //  Austrelia
            if (!regex.test(value)) {
              return 'Invalid postal code'
            }
          } else if (country === '223') {
            regex = new RegExp(/(^\d{5}$)|(^\d{5}-\d{4}$)/) //  USA
            if (!regex.test(value)) {
              return 'Invalid postal code'
            }
          } else if (country === '222') {
            regex = new RegExp(/^[A-Z0-9 ]+$/i) //  UK
            if (!regex.test(value)) {
              return 'Invalid postal code'
            }
          } else if (country === '81') {
            regex = new RegExp(/^\b((?:0[1-46-9]\d{3})|(?:[1-357-9]\d{4})|(?:[4][0-24-9]\d{3})|(?:[6][013-9]\d{3}))\b/) //  Germany
            if (!regex.test(value)) {
              return 'Invalid postal code'
            }
          } else if (country === '38') {
            regex = new RegExp(/^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/) //  Canada
            if (!regex.test(value)) {
              return 'Invalid postal code'
            }
          } else if (country === '74') {
            regex = new RegExp(/^(F-)?((2[A|B])|[0-9]{2})[0-9]{3}$/) //  France
            if (!regex.test(value)) {
              return 'Invalid postal code'
            }
          } else {

          }
        })
      },
      city: function (value) {
        return Validator.value(value).required()
      },
      zone_id: function (value) {
        const isSelectedCountryUK = this.isSelectedCountryUK
        const isSelectedCountryUAE = this.isSelectedCountryUAE
        return Validator.value(value).required().custom(function () {
          if (value === 0) {
            if (isSelectedCountryUK) return 'Please select county'
            if (isSelectedCountryUAE) return 'Please select emirate'
            return 'Please select state'
          }
        })
      },
      countryId: function (value) {
        return Validator.value(value).required().custom(function () {
          if (value === 0) {
            return 'Please select state'
          }
        })
      },
      phone_no: function (value) {
        const filterCountry = this.countries.find(obj => parseInt(obj.id) === parseInt(this.countryId))
        const countryPhoneLength = filterCountry.phone_no_length
        const countryPhoneMinLength = filterCountry && filterCountry.phone_no_min_length || 10
        // Validator.value(value).required().minLength(10).maxLength(10).digit('Must be number')
        let regexMobile
        if (this.isSelectedCountryUK) {
          regexMobile = /^[0-9]{10,11}$/
        } else if (this.isSelectedCountryUAE) {
          regexMobile = /^[1-9]{1}[0-9]{7,8}$/
        } else {
          regexMobile = /^[1-9]{1}[0-9]{9}$/
        }
        const isSelectedCountryUAE = this.isSelectedCountryUAE
        const isSelectedCountryUK = this.isSelectedCountryUK
        return Validator.custom(function () {
          if (isSelectedCountryUAE && value && value.trim().length < countryPhoneMinLength) return `Must have ${countryPhoneMinLength} digits at least.`
          if (isSelectedCountryUK && value && value.trim().length < countryPhoneMinLength) return `Must have ${countryPhoneMinLength} digits at least.`
          if (!isSelectedCountryUAE && !isSelectedCountryUK && value && value.trim().length < countryPhoneLength) return `Must have ${countryPhoneLength} digits at least.`
          if (!Validator.isEmpty(value)) {
            if (isSelectedCountryUAE && value.length < 8) return `Must have ${8} digits at least.`
            if (isSelectedCountryUK && value.length < 10) return `Must have ${10} digits at least.`
            if (!isSelectedCountryUAE && !isSelectedCountryUK && value.length < countryPhoneLength) {
              return `Must have ${countryPhoneLength} digits at least.`
            }
            if (!regexMobile.test(value)) {
              return 'Please enter valid mobile number.'
            }
          }
        })
      },
      email: function (value) {
        if (this.isNewUser && !(this.getUser && this.getUser.email)) {
          return Validator.value(value).required()
        }
      },
      gender: function (value) {
        if (this.isNewUser && !(this.getUser && this.getUser.email)) {
          return Validator.value(value).required()
        }
      }
    },
    computed: {
      ...mapGetters({countries: 'countries', zones: 'zones', addresses: 'addresses', _cart: '_cart', googleGeoCodeAddressData: 'googleGeoCodeAddressData', buyNowAddresses: 'buyNowAddresses', _buyNowCart: '_buyNowCart', globalBannerPlaceholder: 'globalBannerPlaceholder', getUserTatvicBuyNowItem: 'getUserTatvicBuyNowItem', country_detail_data: 'country_detail_data'}),
      zoneget: function () {
        var zn = this.zonefor
        return zn
      },
      isNewUser () {
        return Vue.ls.get('is_new_user')
      },
      postcodeLength () {
        const pincode = this.globalBannerPlaceholder && this.globalBannerPlaceholder.length && this.globalBannerPlaceholder.find(bannerData =>
        bannerData.is_active === true && bannerData.config_key === 'pincode_length_validation')
        if (this.countryId === 222) {
          return 8
        }
        if (pincode) {
          return pincode.value
        } else {
          return 6
        }
      },
      isSelectedCountryIndia () {
        return this.countryId ? parseInt(this.countryId) === 99 : false
      },
      isSelectedCountryUK () {
        return this.countryId ? parseInt(this.countryId) === 222 : false
      },
      isSelectedCountryUAE () {
        return this.countryId ? parseInt(this.countryId) === 221 : false
      }
    },
    watch: {
      address1 (value) {
        this.validateAddress('address1', value)
      },
      address2 (value) {
        this.validateAddress('address2', value)
      },
      address3 (value) {
        this.validateAddress('address3', value)
      },
      postcode () {
        //  debounce postcode
        const self = this
        clearTimeout(this.timeout)
        this.timeout = setTimeout(function () {
          // handle stuff, call API etc. after 1 second
          self.$validate('postcode').then((success) => {
            if (success) {
              self.$store.dispatch('GET_DELIVERY_DETAILS_FROM_PINCODE', { pincode: self.postcode }).then(res => {
                if (res && res.success) {
                  self.city = res.data.city
                  let tempZoneData = self.zones && self.zones.filter((zn) => {
                    return zn.name === res.data.state
                  })
                  self.zone_id = tempZoneData[0].id
                }
              })
            }
          })
        }, 500)
      }
    }
  }
</script>
<style scoped="scoped">
  .modalcon {
    position: fixed;
    display: block;
    left: 0;
    z-index: 9998;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    overflow-x: hidden;
    overflow-y: auto;
    transition: opacity .3s ease;
  }

  .modal-mask { /*  position: fixed;*/
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: table;
  }

  .closebtn {
    padding: 5px;
    font-weight: bold;
    cursor: pointer;
  }

  .modal-wrapper {
    display: table-cell;
    vertical-align: middle;
  }

  .modal-container {
    width: 550px;
    margin: 0px auto;
    padding: 10px;
    background-color: #fff;
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
    transition: all .3s ease;
    font-family: Helvetica, Arial, sans-serif;
  }

  .modal-header {
    padding: 5px;
  }

  .modal-header h3 {
    margin-top: 0;
    color: #42b983;
  }

  .modal-footer {
    padding: 15px 5px 5px 5px;
  }

  .modal-body {
    margin: 20px 0 0px 0;
    padding: 5px;
  }

  .modal-default-button {
    float: right;
  }

  .modal-enter {
    opacity: 0;
  }

  .modal-leave-active {
    opacity: 0;
  }

  .modal-enter .modal-container,
  .modal-leave-active .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }
  .svgControl{
    margin-right: 6px;
    vertical-align: middle;
  }
  /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  /* Firefox */
  input[type=number] {
    -moz-appearance: textfield;
  }
  @media screen and (max-width: 768px) {
    .modal-container {
      width: 85%;
    }
  }
.country-phone-code {
  position: relative;
}
.country-phone-code .country-code {
  width: 65px;
  height: 39px !important;
  position: absolute;
  left: 0;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 15px;
  font-family: 'Source Sans Pro', sans-serif;
  border-color: #D9D9D9;
  border-right: 1px solid #eee;
  border-radius: 10px 0 0 10px;
  color: #58595b;
  padding: 0 5px;
}
.country-phone-code input {
  padding-left: 70px;
}
</style>



// WEBPACK FOOTER //
// newAddress.vue?7f2228ce